import { useEffect } from "react";
import { ActionIcon, Checkbox, Tooltip } from "@mantine/core";
import { IconInfoCircle } from "@tabler/icons-react";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { setBadDetection } from "@/store";
import { JobTaskDetailSchema } from "@augmodo/lebron-browser-client";

const ProductAssociationImageChecks = ({
  task,
}: {
  task: JobTaskDetailSchema;
}) => {
  const dispatch = useAppDispatch();
  const badDetection = useAppSelector(
    (state) => state.productAssociation.badDetection,
  );

  useEffect(() => {
    if (
      task?.data?.confirmation_result?.bad_detection ||
      task.result?.bad_detection
    ) {
      dispatch(setBadDetection(true));
    }
  }, [task]);

  return (
    <div className="flex items-center justify-center gap-2 pt-4">
      <Checkbox
        label="Is Bad Detection"
        checked={badDetection}
        onChange={(event) => {
          dispatch(setBadDetection(event.currentTarget.checked));
        }}
        classNames={{
          body: "items-center",
          label: "text-lg",
        }}
      />
      <Tooltip
        label={
          <div>
            <div>• Box covers less than 25% of the product</div>
            <div>• Box covers more than 1 product</div>
            <div>• Box does not show a product</div>
          </div>
        }
        multiline
      >
        <ActionIcon variant="transparent">
          <IconInfoCircle />
        </ActionIcon>
      </Tooltip>
    </div>
  );
};

export default ProductAssociationImageChecks;
